import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setIsBankAnalysisRequired } from "shared/redux/common-reducer";
import { Button, Modal } from "antd";
import { useHistory } from "react-router-dom";

interface ICloseWarningBSA {
  closeWarningBSALocation: string;
  setCloseWarningBSAlocation: (value: React.SetStateAction<string>) => void;
  callBack?: any;
}

const CloseWarningBSA: React.FC<ICloseWarningBSA> = (props: ICloseWarningBSA) => {
  const { closeWarningBSALocation, setCloseWarningBSAlocation, callBack } = props;

  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <Modal
      title=""
      centered
      width={400}
      closable={false}
      footer={null}
      visible={closeWarningBSALocation?.length > 0}
    >
      <div className="delete-modal">
        <span>
          {
            "You have unsaved data in the Bank Statement Analyzer. Exiting now will result in losing the uploaded data. Are you sure you want to proceed?"
          }
        </span>
        <div className="delete-modal-btn">
          <Button
            className="app-btn-border"
            onClick={() => setCloseWarningBSAlocation("")}
          >
            Close
          </Button>
          <Button
            className="app-btn-primary-bg"
            onClick={() => {
              dispatch(setIsBankAnalysisRequired(false));
              setCloseWarningBSAlocation("");
              if(closeWarningBSALocation.includes("/")) {
                history.push(closeWarningBSALocation);
              } else {
                callBack(closeWarningBSALocation)
              }
            }}
          >
            Proceed
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CloseWarningBSA;
